import * as React from "react";
import type { SVGProps } from "react";
const SvgClipboardText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={36}
    fill="none"
    {...props}
  >
    <path
      fill="#79AFFF"
      d="M24.36 5.475H11.64c-3.705 0-6.705 3.015-6.705 6.705v14.115C4.935 29.985 7.95 33 11.64 33h12.705c3.705 0 6.705-3.015 6.705-6.705V12.18c.015-3.705-3-6.705-6.69-6.705Z"
      opacity={0.4}
    />
    <path
      fill="#79AFFF"
      d="M21.525 3h-7.05a2.83 2.83 0 0 0-2.835 2.82v1.41c0 1.56 1.26 2.82 2.82 2.82h7.065c1.56 0 2.82-1.26 2.82-2.82V5.82C24.36 4.26 23.085 3 21.525 3ZM22.5 19.425H12c-.615 0-1.125-.51-1.125-1.125s.51-1.125 1.125-1.125h10.5c.615 0 1.125.51 1.125 1.125s-.51 1.125-1.125 1.125ZM18.57 25.425H12c-.615 0-1.125-.51-1.125-1.125s.51-1.125 1.125-1.125h6.57c.615 0 1.125.51 1.125 1.125s-.51 1.125-1.125 1.125Z"
    />
  </svg>
);
export default SvgClipboardText;
